import React, { useState, useEffect } from "react";
import axios from "axios";
import { Box, Flex, Button, Text, Table, Thead, Tbody, Tr, Th, useDisclosure, Td, GridItem, Input, Select, HStack, IconButton, useToast, Modal, ModalOverlay, ModalContent, ModalHeader, ModalBody, ModalFooter, VStack, FormControl, FormLabel, InputGroup, InputRightElement, Switch, Card, CardBody, StackDivider, Badge, useBreakpointValue, Tabs, TabList, TabPanel, TabPanels, Tab, Grid } from "@chakra-ui/react";
import { FaPlus, FaEdit, FaTrash, FaArrowLeft, FaUser, FaBullseye, FaEye, FaEyeSlash } from 'react-icons/fa';

export default function MasterDataUser({ onBack }) {
  const toast = useToast();
  const [users, setUsers] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [modalType, setModalType] = useState('profile');
  const [form, setForm] = useState({});
  const isMobile = useBreakpointValue({ base: true, md: false });
  const [isAddOpen, setIsAddOpen] = useState(false);
  const [newUser, setNewUser] = useState({
    name: '', email: '', password: '', jenis_kelamin: 'pria', tanggal_lahir: ''
  });
  const [showAddPwd, setShowAddPwd] = useState(false);
  const [pwd, setPwd] = useState({ old: '', new: '', confirm: '' });
  const [pwdError, setPwdError] = useState('');
  const [pwdStrength, setPwdStrength] = useState({ score: 0, label: '', color: 'gray' });
  const [showPwd, setShowPwd] = useState({ old: false, new: false, confirm: false });

  const showToast = (title, status = 'info') => {
    toast({ title, status, duration: 3000, isClosable: true, position: 'top' });
  };

  const loadUsers = async () => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_API_BASE}/get-users`);
      setUsers(res.data.users || []);
    } catch (err) {
      showToast('Gagal load user: ' + err.message, 'error');
    }
  };

  useEffect(() => { loadUsers(); }, []);

  const openModal = (user, type) => {
    setSelectedUser(user);
    setModalType(type);
    setForm(user);
    setPwd({ old: '', new: '', confirm: '' });
    onOpen();
  };

  const handleSaveAdd = async () => {
    if (!newUser.name ||!newUser.email ||!newUser.password) {
      return showToast('Nama, Email, Password wajib diisi', 'warning');
    }
    if (newUser.password.length < 6) {
      return showToast('Password minimal 6 karakter', 'warning');
    }
    try {
      await axios.post(`${process.env.REACT_APP_API_BASE}/add-user`, newUser);
      showToast('User berhasil ditambahkan', 'success');
      setIsAddOpen(false);
      setNewUser({ name: '', email: '', password: '', jenis_kelamin: 'pria', tanggal_lahir: '' });
      loadUsers();
    } catch (err) {
      showToast(err.response?.data?.message || 'Gagal tambah user', 'error');
    }
  };

  const cekPasswordStrength = (password) => {
    let score = 0;
    if (password.length >= 6) score += 1;
    if (password.length >= 8) score += 1;
    if (/[A-Z]/.test(password)) score += 1;
    if (/[0-9]/.test(password)) score += 1;
    if (/[^A-Za-z0-9]/.test(password)) score += 1;
    const levels = [
      { score: 0, label: '', color: 'gray' },
      { score: 1, label: 'Sangat Lemah', color: 'red' },
      { score: 2, label: 'Lemah', color: 'orange' },
      { score: 3, label: 'Cukup', color: 'yellow' },
      { score: 4, label: 'Kuat', color: 'blue' },
      { score: 5, label: 'Sangat Kuat', color: 'green' }
    ];
    return levels[score];
  };

  const handleSave = async () => {
    if (pwd.new || pwd.confirm || pwd.old) {
      if (!pwd.old) return showToast('Masukkan Old Password', 'warning');
      if (pwd.new.length < 6) return showToast('New Password minimal 6 karakter', 'warning');
      if (pwd.new!== pwd.confirm) return showToast('New Password dan Confirm beda', 'error');
    }
    try {
      await axios.post(`${process.env.REACT_APP_API_BASE}/update-user-profile`, {
        id: selectedUser.id,...form
      });
      if (pwd.new) {
        await axios.post(`${process.env.REACT_APP_API_BASE}/update-user-password`, {
          id: selectedUser.id, old_password: pwd.old, new_password: pwd.new
        });
      }
      showToast('Data berhasil diupdate', 'success');
      setPwd({ old: '', new: '', confirm: '' });
      onClose();
      loadUsers();
    } catch (err) {
      showToast(err.response?.data?.message || 'Gagal simpan', 'error');
    }
  };

  const toggleActive = async (id, is_active) => {
    try {
      await axios.post(`${process.env.REACT_APP_API_BASE}/toggle-user`, { id, is_active: is_active? 0 : 1 });
      loadUsers();
    } catch (err) {
      showToast('Gagal update status', 'error');
    }
  };

  const hitungUmur = (tgl) => {
    if (!tgl) return '-';
    const diff = Date.now() - new Date(tgl).getTime();
    return Math.floor(diff / (1000 * 60 * 60 * 24 * 365.25));
  };

  return (
    <Box p={{ base: 2, md: 4 }}>
      <Flex justify="space-between" mb={4} align="center">
        <Button leftIcon={<FaArrowLeft />} onClick={onBack} variant="ghost" size="sm">Kembali</Button>
        <Text fontSize={{ base: 'lg', md: 'xl' }} fontWeight="bold">Master Data User</Text>
        <Button leftIcon={<FaPlus />} colorScheme="green" size="sm" onClick={() => {
          setNewUser({ name: '', email: '', password: '', jenis_kelamin: 'pria', tanggal_lahir: '' });
          setShowAddPwd(false);
          setIsAddOpen(true);
        }}>Tambah User</Button>
      </Flex>

      {/* Desktop Table */}
      <Box display={{ base: 'none', md: 'block' }} overflowX="auto" borderWidth="1px" borderRadius="lg">
        <Table size="sm">
          <Thead bg="gray.50">
            <Tr>
              <Th>ID</Th><Th>Nama</Th><Th>Email</Th><Th>JK</Th><Th>Umur</Th><Th>Target Kkal</Th><Th>Status</Th><Th>Aksi</Th>
            </Tr>
          </Thead>
          <Tbody>
            {users.map(u => (
              <Tr key={u.id}>
                <Td>{u.id}</Td>
                <Td fontWeight="semibold">{u.name}</Td>
                <Td fontSize="sm">{u.email}</Td>
                <Td><Badge colorScheme={u.jenis_kelamin === 'pria'? 'blue' : 'pink'}>{u.jenis_kelamin}</Badge></Td>
                <Td>{hitungUmur(u.tanggal_lahir)} thn</Td>
                <Td>{u.target_kalori} kkal</Td>
                <Td><Switch size="sm" isChecked={u.is_active === 1} onChange={() => toggleActive(u.id, u.is_active)} /></Td>
                <Td>
                  <HStack spacing={1}>
                    <IconButton icon={<FaUser />} size="xs" onClick={() => openModal(u, 'profile')} />
                    <IconButton icon={<FaBullseye />} size="xs" colorScheme="purple" onClick={() => openModal(u, 'target')} />
                  </HStack>
                </Td>
              </Tr>
            ))}
          </Tbody>
        </Table>
      </Box>

      {/* Mobile Card */}
      <VStack spacing={3} display={{ base: 'flex', md: 'none' }} align="stretch">
        {users.map(u => (
          <Card key={u.id} borderWidth="1px" shadow="sm">
            <CardBody p={3}>
              <VStack align="stretch" divider={<StackDivider borderColor="gray.100" />} spacing={2}>
                <Flex justify="space-between">
                  <Text fontWeight="bold">{u.name}</Text>
                  <Badge colorScheme={u.jenis_kelamin === 'pria'? 'blue' : 'pink'} fontSize="xs">{u.jenis_kelamin}</Badge>
                </Flex>
                <Text fontSize="xs" color="gray.600">{u.email}</Text>
                <HStack justify="space-between" fontSize="sm">
                  <Text>Umur: <b>{hitungUmur(u.tanggal_lahir)} thn</b></Text>
                  <Text>Target: <b>{u.target_kalori} kkal</b></Text>
                </HStack>
                <Flex justify="space-between" align="center" pt={2}>
                  <HStack><Text fontSize="sm">Aktif</Text><Switch size="sm" isChecked={u.is_active === 1} onChange={() => toggleActive(u.id, u.is_active)} /></HStack>
                  <HStack>
                    <Button leftIcon={<FaUser />} size="xs" onClick={() => openModal(u, 'profile')}>Profile</Button>
                    <Button leftIcon={<FaBullseye />} size="xs" colorScheme="purple" onClick={() => openModal(u, 'target')}>Target</Button>
                  </HStack>
                </Flex>
              </VStack>
            </CardBody>
          </Card>
        ))}
      </VStack>

      {/* Modal Edit */}
      <Modal isOpen={isOpen} onClose={onClose} size={isMobile? 'full' : 'xl'}>
        <ModalOverlay />
        <ModalContent borderRadius={isMobile? 0 : 'lg'}>
          <ModalHeader fontSize="md">{modalType === 'profile'? 'Edit Profile' : 'Edit Target Nutrisi'} - {selectedUser?.name}</ModalHeader>
          <ModalBody overflowY="auto">
            {modalType === 'profile'? (
              <VStack spacing={4} align="stretch">
                <Grid templateColumns={{ base: '1fr', md: 'repeat(2, 1fr)' }} gap={4}>
                  <GridItem><FormLabel>Nama</FormLabel><Input value={form.name || ''} onChange={e => setForm({...form, name: e.target.value})} /></GridItem>
                  <GridItem><FormLabel>Email</FormLabel><Input value={form.email || ''} onChange={e => setForm({...form, email: e.target.value})} /></GridItem>
                  <GridItem><FormLabel>Jenis Kelamin</FormLabel><Select value={form.jenis_kelamin} onChange={e => setForm({...form, jenis_kelamin: e.target.value})}><option value="pria">Pria</option><option value="wanita">Wanita</option></Select></GridItem>
                  <GridItem><FormLabel>Tanggal Lahir</FormLabel><Input type="date" value={form.tanggal_lahir?.split('T')[0]} onChange={e => setForm({...form, tanggal_lahir: e.target.value})} /></GridItem>
                </Grid>
                <Box borderTop="1px solid" borderColor="gray.200" pt={4} mt={2}>
                  <Text fontWeight="bold" mb={3}>Ganti Password</Text>
                  <VStack spacing={3}>
                    <FormControl><FormLabel fontSize="sm">Old Password</FormLabel><Input type="password" value={pwd.old} onChange={e => setPwd({...pwd, old: e.target.value})} /></FormControl>
                    <FormControl><FormLabel fontSize="sm">New Password</FormLabel>
                      <InputGroup><Input type={showPwd.new? 'text' : 'password'} value={pwd.new} onChange={e => {setPwd({...pwd, new: e.target.value}); setPwdStrength(cekPasswordStrength(e.target.value));}} />
                      <InputRightElement><IconButton size="sm" variant="ghost" icon={showPwd.new? <FaEyeSlash /> : <FaEye />} onClick={() => setShowPwd({...showPwd, new:!showPwd.new})} /></InputRightElement></InputGroup>
                    </FormControl>
                    <FormControl isInvalid={pwdError!== ''}><FormLabel fontSize="sm">Confirm</FormLabel><Input type="password" value={pwd.confirm} onChange={e => {setPwd({...pwd, confirm: e.target.value}); if(pwd.new!== e.target.value) setPwdError('Password beda'); else setPwdError('');}} />{pwdError && <Text color="red.500" fontSize="xs">{pwdError}</Text>}</FormControl>
                  </VStack>
                </Box>
              </VStack>
            ) : (
              <Tabs size="sm"><TabList><Tab>Kalori</Tab><Tab>Makro</Tab><Tab>Mikro</Tab></TabList>
                <TabPanels>
                  <TabPanel><FormControl><FormLabel>Target Kalori</FormLabel><Input type="number" value={form.target_kalori || 0} onChange={e => setForm({...form, target_kalori: parseInt(e.target.value)})} /></FormControl></TabPanel>
                  <TabPanel><Grid templateColumns="repeat(3, 1fr)" gap={3}><Box><FormLabel>Karbo</FormLabel><Input type="number" value={form.target_carbs || 0} onChange={e => setForm({...form, target_carbs: parseInt(e.target.value)})} /></Box><Box><FormLabel>Protein</FormLabel><Input type="number" value={form.target_protein || 0} onChange={e => setForm({...form, target_protein: parseInt(e.target.value)})} /></Box><Box><FormLabel>Lemak</FormLabel><Input type="number" value={form.target_fat || 0} onChange={e => setForm({...form, target_fat: parseInt(e.target.value)})} /></Box></Grid></TabPanel>
                  <TabPanel><Grid templateColumns="repeat(2, 1fr)" gap={3}><Box><FormLabel>Serat</FormLabel><Input type="number" value={form.target_serat || 0} onChange={e => setForm({...form, target_serat: parseFloat(e.target.value)})} /></Box><Box><FormLabel>Gula</FormLabel><Input type="number" value={form.target_gula || 0} onChange={e => setForm({...form, target_gula: parseFloat(e.target.value)})} /></Box><Box><FormLabel>Sodium</FormLabel><Input type="number" value={form.target_sodium || 0} onChange={e => setForm({...form, target_sodium: parseFloat(e.target.value)})} /></Box><Box><FormLabel>Kalium</FormLabel><Input type="number" value={form.target_kalium || 0} onChange={e => setForm({...form, target_kalium: parseFloat(e.target.value)})} /></Box></Grid></TabPanel>
                </TabPanels>
              </Tabs>
            )}
          </ModalBody>
          <ModalFooter><Button onClick={onClose} mr={3}>Batal</Button><Button colorScheme="purple" onClick={handleSave}>Simpan</Button></ModalFooter>
        </ModalContent>
      </Modal>

      {/* Modal Tambah User */}
      <Modal isOpen={isAddOpen} onClose={() => setIsAddOpen(false)} size={isMobile? 'full' : 'md'}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Tambah User Baru</ModalHeader>
          <ModalBody>
            <VStack spacing={3}>
              <FormControl isRequired><FormLabel>Nama</FormLabel><Input value={newUser.name} onChange={e => setNewUser({...newUser, name: e.target.value})} /></FormControl>
              <FormControl isRequired><FormLabel>Email</FormLabel><Input type="email" value={newUser.email} onChange={e => setNewUser({...newUser, email: e.target.value})} /></FormControl>
              <FormControl isRequired><FormLabel>Password</FormLabel><InputGroup><Input type={showAddPwd? 'text' : 'password'} value={newUser.password} onChange={e => setNewUser({...newUser, password: e.target.value})} /><InputRightElement><IconButton size="sm" variant="ghost" icon={showAddPwd? <FaEyeSlash /> : <FaEye />} onClick={() => setShowAddPwd(!showAddPwd)} /></InputRightElement></InputGroup></FormControl>
              <FormControl><FormLabel>Jenis Kelamin</FormLabel><Select value={newUser.jenis_kelamin} onChange={e => setNewUser({...newUser, jenis_kelamin: e.target.value})}><option value="pria">Pria</option><option value="wanita">Wanita</option></Select></FormControl>
              <FormControl><FormLabel>Tanggal Lahir</FormLabel><Input type="date" value={newUser.tanggal_lahir} onChange={e => setNewUser({...newUser, tanggal_lahir: e.target.value})} /></FormControl>
            </VStack>
          </ModalBody>
          <ModalFooter><Button onClick={() => setIsAddOpen(false)} mr={3}>Batal</Button><Button colorScheme="green" onClick={handleSaveAdd}>Simpan</Button></ModalFooter>
        </ModalContent>
      </Modal>
    </Box>
  );
}